module.exports = __webpack_public_path__ + "static/img/icon-p3-6gs.dddd55ba.png";